import { render, staticRenderFns } from "./edit-videoswebinars-modal.vue?vue&type=template&id=61901be7&scoped=true"
import script from "./edit-videoswebinars-modal.vue?vue&type=script&lang=js"
export * from "./edit-videoswebinars-modal.vue?vue&type=script&lang=js"
import style0 from "./edit-videoswebinars-modal.vue?vue&type=style&index=0&id=61901be7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61901be7",
  null
  
)

export default component.exports